<div class="raisenow-payment" [class.raisenow-payment--has-iframe]="showIframe">
  @if (
    offline &&
    ![
      PaymentStatus.Success,
      PaymentStatus.Failed,
      PaymentStatus.Canceled,
    ].includes(paymentStatus)
  ) {
    <div
      class="raisenow-status raisenow-status--muted"
      [class.raisenow-status--overlay]="showIframe"
    >
      <fa-icon [icon]="_iconOffline" size="3x" class="raisenow-status__icon" />
      <p>{{ 'raisenow_offline_status' | translate }}</p>
    </div>
  } @else {
    @if (serviceUnavailable) {
      <div class="raisenow-status">
        <fa-icon
          [icon]="_iconServiceUnavailable"
          size="3x"
          class="raisenow-status__icon"
        />
        <div>
          <h3>{{ 'raisenow_iframe_error_heading' | translate }}</h3>
          <p>{{ 'raisenow_iframe_error_paragraph' | translate }}</p>
        </div>
      </div>
    }

    @if (responseError) {
      <div class="raisenow-status raisenow-status--error">
        <fa-icon [icon]="_iconError" size="3x" class="raisenow-status__icon" />
        <div>
          <h3>{{ responseErrorHeading }}</h3>
          <p>{{ responseErrorParagraph }}</p>
        </div>
      </div>
    }
  }

  @if (isIndicatorLoading && !offline && !serviceUnavailable) {
    <div class="raisenow-status" [class.raisenow-status--overlay]="showIframe">
      <fmnts-loading-indicator size="sm" />
      <p [hidden]="!hasPaymentStarted">
        {{ 'raisenow_iframe_loading_paragraph' | translate }}
      </p>
    </div>
  }

  <div
    #raiseNowIframeEPP
    id="raiseNowIframeEPP"
    class="iframe-wrapper"
    [class.hidden]="isMpos || !showIframe"
  ></div>

  @if (isMpos) {
    <div>
      @if (PaymentStatus.Pending === paymentStatus && !offline) {
        <div class="raisenow-status">
          <fa-icon [icon]="_iconMpos" size="2x" class="raisenow-status__icon" />

          <h3>
            {{ 'raisenow_epp_mpos_pending_title' | translate }}
          </h3>
          <p>
            {{ 'raisenow_epp_mpos_pending_description' | translate }}
          </p>
        </div>
      }
      @if (PaymentStatus.Canceled === paymentStatus) {
        <div class="raisenow-status raisenow-status--warning">
          <fa-icon
            [icon]="_iconWarning"
            size="3x"
            class="raisenow-status__icon"
          />

          <h3>
            {{ 'raisenow_epp_mpos_canceled_title' | translate }}
          </h3>
          <p>{{ 'raisenow_epp_mpos_canceled_description' | translate }}</p>
        </div>
      }
    </div>
  }
</div>

<fmnts-modal-actions>
  @if (_canCancel$ | async) {
    <button
      type="button"
      fmnts-button
      (click)="cancelPayment()"
      class="form-action white"
    >
      {{
        ([PaymentStatus.Failed, PaymentStatus.Canceled].includes(paymentStatus)
          ? 'back'
          : 'cancel'
        ) | translate
      }}
    </button>
  }
  @if (showIframe) {
    <button
      type="button"
      fmnts-button
      color="primary"
      fill="solid"
      (click)="sendPayment()"
      class="form-action blue"
      [disabled]="isPaymentButtonDisabled || offline"
    >
      @if (showButtonLoadingIndicator) {
        <fmnts-loading-indicator size="xs" class="next-modal__button-icon" />
      } @else {
        <fa-icon [icon]="_iconStartPayment" class="next-modal__button-icon" />
      }

      {{
        showButtonLoadingIndicator
          ? ('raisenow_pay_button_processing' | translate)
          : ('raisenow_pay_button' | translate)
      }}
    </button>
  }
</fmnts-modal-actions>
